// timeline zoom is a percentage of TIMELINE_TWEEN.minWidth px per second (see calcTimelineRowWidth)
export const timelineMinZoom: number = 10
export const timelineMaxZoom: number = 2000
export const timelineZoomStep: number = 10

export const clampTimelineZoom = (zoom: number): number =>
    Math.min(Math.max(zoom, timelineMinZoom), timelineMaxZoom)
